"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoQualityLevel = exports.TranscodeScoreLevel = exports.SourceScoreLevel = void 0;
var bitrate_switching_1 = require("./bitrate-switching");
Object.defineProperty(exports, "SourceScoreLevel", { enumerable: true, get: function () { return bitrate_switching_1.SourceScoreLevel; } });
Object.defineProperty(exports, "TranscodeScoreLevel", { enumerable: true, get: function () { return bitrate_switching_1.TranscodeScoreLevel; } });
Object.defineProperty(exports, "AutoQualityLevel", { enumerable: true, get: function () { return bitrate_switching_1.AutoQualityLevel; } });
//# sourceMappingURL=types.js.map